import { useHistory, useLocation } from "react-router-dom"

const useHistoryCustom = () => {
  const history = useHistory()
  const location = useLocation()

  const push = (url: string, state?: any) =>
    history.push({ pathname: url, search: location.search, state })

  const replace = (url: string) =>
    history.replace({ pathname: url, search: location.search })

  const goBack = () => history.goBack()

  return { push, goBack, replace }
}

export default useHistoryCustom
